var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_menu_type_2"),
        visible: _vm.visible,
        size: "480px",
        direction: "rtl",
      },
      on: { close: _vm.handleCancel },
    },
    [
      _c(
        "yxt-form",
        {
          ref: "formRef",
          staticClass: "form-wrapper",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "is-need-require": "",
            "is-need-tooltip": "",
          },
        },
        [
          _c(
            "yxt-form-item",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                label: _vm.$t("pc_select_role_label"),
                prop: "auditRole",
              },
            },
            [
              _c(
                "yxt-select",
                {
                  attrs: {
                    placeholder: _vm.$t("pc_select_placeholder"),
                    "value-key": "id",
                    "prop-label": "roleName",
                    disabled: !_vm.options.length,
                  },
                  model: {
                    value: _vm.formData.auditRole,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "auditRole", $$v)
                    },
                    expression: "formData.auditRole",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("yxt-option", {
                    key: item.id,
                    attrs: { label: item.roleName, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.formData.auditRole && _vm.options.length > 0
            ? _c(
                "yxt-form-item",
                {
                  staticClass: "sel-type-item",
                  attrs: { label: _vm.$t("pc_audit_multi") },
                },
                [
                  _c(
                    "yxt-radio-group",
                    {
                      staticClass: "role-radio",
                      model: {
                        value: _vm.formData.auditType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "auditType", $$v)
                        },
                        expression: "formData.auditType",
                      },
                    },
                    [
                      _c(
                        "yxt-radio",
                        { attrs: { label: 0 } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("pc_audit_or")) +
                              "\n          "
                          ),
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("pc_audit_or_tip"),
                              },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "ml4 color-gray-7",
                                attrs: {
                                  "icon-class": "question-cirlce-o",
                                  width: "16px",
                                  height: "16px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "yxt-radio",
                        { attrs: { label: 1 } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("pc_audit_and")) +
                              "\n          "
                          ),
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("pc_audit_and_tip"),
                              },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "ml4 color-gray-7",
                                attrs: {
                                  "icon-class": "question-cirlce-o",
                                  width: "16px",
                                  height: "16px",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("pc_cancel_mini")))]
          ),
          _c(
            "yxt-button",
            {
              attrs: { type: "primary", disabled: !_vm.formData.auditRole },
              on: { click: _vm.handleOk },
            },
            [_vm._v(_vm._s(_vm.$t("pc_ok_mini")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }